export const iconFontAwesomeArrowsArrowRightFromBracket = (
	<i className="fa-solid fa-arrow-right-from-bracket"></i>
);
